<fw-progress-spinner mode="indeterminate" size="medium"></fw-progress-spinner>
<div class="message"><ng-content></ng-content></div>
<div class="default">{{ 'common.labels.loading' | translate }}</div>
